jQuery(document).ready(function ($) {

  const navBarList = [];
  const navBarDropdown = $('.navBarDropdown');
  const navBarDropdownWidth = navBarDropdown.outerWidth(true);
  let navBarTotalWidth = 0;
  let navBarContainerWidth;

  function facilityNavHandler() {
    let itemWidth = 0;
    navBarContainerWidth = $('.navBarContainer').outerWidth(true);

    $('.navBarItem').each(function () {
      itemWidth = $(this).outerWidth(true);
      navBarList.push({
        visible: true,
        width: itemWidth
      });
      navBarTotalWidth += itemWidth;
    });

    let navBarItemsWidth = 0;

    navBarList.forEach(item => {
      navBarItemsWidth += item.width;
      item.visible = navBarItemsWidth + navBarDropdownWidth < navBarContainerWidth;
    });

    $('.navBarItem').each(function (index) {
      if (navBarList[index].visible) {
        $(this).removeClass('d-none');
      }
      else {
        $(this).addClass('d-none');
      }
    });

    $('.navBarDropdownItem').each(function (index) {
      if (!navBarList[index].visible) {
        $(this).removeClass('d-none');
      }
      else {
        $(this).addClass('d-none');
      }
    });

    if (navBarTotalWidth + navBarDropdownWidth < navBarContainerWidth) {
      navBarDropdown.addClass('d-none');
    } else {
      navBarDropdown.removeClass('d-none');
    }
  }

  facilityNavHandler();
  $('.navBarContainer').removeClass('jsNavBarContainerHidden');

  $(window).on('resize', function () {
    facilityNavHandler();
  });

});
